import * as FileSystem from 'expo-file-system'
import { Platform, Share } from 'react-native'
import * as Sentry from '@sentry/react-native'
import { Alert } from 'react-native'

export interface CSVRow {
  [key: string]: string | number
}

export function generateCSV(headers: string[], rows: string[][]): string {
  const csvLines = [
    headers.join(','),
    ...rows.map((row) => row.map((cell) => `"${cell}"`).join(',')),
  ]
  return csvLines.join('\n')
}

export async function downloadCSV(
  csv: string,
  filename: string
): Promise<void> {
  try {
    if (Platform.OS === 'web') {
      // Web implementation: create a download link
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)

      link.setAttribute('href', url)
      link.setAttribute('download', filename)
      link.style.visibility = 'hidden'

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      // Clean up the URL object
      URL.revokeObjectURL(url)
    } else {
      // Mobile implementation: write to file and share
      const fileUri = `${FileSystem.Paths.document.uri}${filename}`

      await FileSystem.writeAsStringAsync(fileUri, csv, {
        encoding: 'utf8',
      })

      await Share.share({
        url: fileUri,
        title: 'Export CSV',
      })
    }
  } catch (error) {
    console.error('Error downloading CSV:', error)
    Sentry.captureException(error)
    Alert.alert('Error', (error as Error).message)
  }
}
